function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
let currencyFormat = window.theme.settings.currencyCodeEnabled ? window.theme.settings.moneyWithCurrencyFormat : window.theme.settings.moneyFormat;

if(document.getElementById("cart-drawer-timer-alert")){
  var countDownDate = new Date().getTime() + (15 * 60 * 1000);              
  setTimeout(function() {
    var x = setInterval(function() {
      var now = new Date().getTime();              
      var distance = countDownDate - now; 
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
      var htmlContent = "";
      if (days > 0) {
        htmlContent += `<span class="pdp-at-item_count">${days}<span>d : </span></span>`;
      }
      if (hours > 0) {
        htmlContent += `<span class="pdp-at-item_count">${hours}<span>h : </span></span>`;
      }
      if (minutes > 0) {
        htmlContent += `<span class="pdp-at-item_count">${minutes}<span>m : </span></span>`;
      }
      if (seconds > 0 || (days <= 0 && hours <= 0 && minutes <= 0)) { 
        // Show seconds if it’s the last remaining unit
        htmlContent += `<span class="pdp-at-item_count">${seconds}<span>s</span></span>`;
      }
      document.getElementById("cart-drawer-timer-alert").innerHTML = htmlContent; 
      // When countdown ends
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("cart-drawer-timer-alert").innerHTML = "EXPIRED";
        document.getElementById("cart-drawer-timer").classList.add('remove');
      } else {
        document.getElementById("cart-drawer-timer").classList.remove('remove');
      }
    }, 1000);
  }, 1500);
}

$(document).ready(function() {
  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.dispatchEvent(new CustomEvent('cart:open'));
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }

  $(".testimonial-custom_row").slick({
      dots: true,
      arrows:false,
      infinite:false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  $(".our-expert_content_grid-list").slick({
    dots: false,
    arrows:true,
    infinite:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
    
  $('.best-products_items-list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    dots: true,
    speed: 300,
    centerPadding: '20px',
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          arrows: false,
        }
      }
    ]
  });

  $(".real-feedback_row").slick({
      dots: false,
      arrows:true,
      infinite:false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768, // under 768px
          settings: "unslick" // destroys slider
        }
      ]
    });
    $(".process_items-list").slick({
      dots: true,
      arrows:false,
      infinite:false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768, // under 768px
          settings: "unslick" // destroys slider
        }
      ]
    });

    $(".slideshow-sec-blocks").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true
    });

    $('.corporate_collection_main-grid-item').each(function () {
      var $item = $(this);
      var $media = $item.find('.corporate_collection_main-grid-item_media-list');
      var $nav   = $item.find('.corporate_collection_main-grid-item_nav-list');

      $media.slick({
        dots: false,
        arrows: false,
        infinite: false,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: false,
        swipe: false,
        asNavFor: $nav // pass the actual jQuery object
      });

      $nav.slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        asNavFor: $media // pass the actual jQuery object
      });
    });


  $('.closer-look_item-add_btn').click(function(){
      $('.closer-look_item').removeClass('active');
      $(this).parents('.closer-look_item').addClass('active');
  });
  $('.closer-look_item-close_btn').click(function(){
      $('.closer-look_item').removeClass('active');
  });
  $('.shop-the-look-dots-item').click(function(){
     var index = $(this).attr('index');
     $('.shop-the-look-dots-item').removeClass('is-selected');
     $(`.shop-the-look-dots-item[index="${index}"]`).addClass('is-selected');
  
     $('.shop-the-look-custom_content-item').removeClass('is-selected');
     $(`.shop-the-look-custom_content-item[index="${index}"]`).addClass('is-selected');
  });

  $('.product-block--accordion_title').click(function(){
   $(this).toggleClass('active');
   $(this).next('.product-block--accordion_content').slideToggle();
  });
  $('.shop-the-look-index-block').click(function(){
    $('.shop-the-look-index-block').removeClass('active');
    $(this).addClass('active');
  });
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.shop-the-look-index-block').length) {
      $('.shop-the-look-index-block').removeClass('active');
    }
  });

  $('.sticky-atc .sticky_maintitle').on('click', function() {
    $('html, body').animate({
      scrollTop: $('[data-product-blocks] .variant-wrapper').offset().top - 100
    }, 500);
  });

  $("body").on("click", ".new-offer-copy_text", function () {
    var copy_text = $(this);
    var text = $(this).attr('code');
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.text("Copied")
      
    setTimeout(function () {
      copy_text.text("Copy");
    }, 1000);
  });

  $('#engraving_text-input').on('input', function () {
    if ($.trim($(this).val()).length > 0) {
      $(this).closest('.product-single__meta').find('[data-add-to-cart]').show();
      $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').hide();
    } else {
      $(this).closest('.product-single__meta').find('[data-add-to-cart]').hide();
      $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').show();
    }
  });

  $('body').on('click', '#engraving_text-check', function(){
    const engraving_alt = $(this).attr('data-engrave').toLowerCase();
    const product_imgs = $(this).parents('.page-content--product').find('.product__thumb-item'); 


    var current_variant_price = parseInt($(this).closest('.product-single__meta').find('[data-product-price]').attr('val'));
    var current_compare_variant_price = parseInt($(this).closest('.product-single__meta').find('[data-compare-price]').attr('val'));

    var engraving_price = parseInt($(this).attr('price'));
    var engraving_compare_price = parseInt($(this).attr('compare_price'));
    if ($(this).is(':checked')) {

      product_imgs.each(function () {
        const media_alt = $(this).attr('data-alt').toLowerCase();
        console.log(media_alt,'media_alt');
        if (media_alt === engraving_alt) {
          console.log('matchedddd')
          $(this).find('.product__thumb').addClass('is-active');
          $(this).find('.product__thumb').find('.image-wrap__thumbnail').click();
        }
      }) 

      $(this).closest('.product-single__meta').find('[data-product-price]').html(formatMoney((current_variant_price + engraving_price), currencyFormat))
      $(this).closest('.product-single__meta').find('[data-compare-price]').html(formatMoney((current_compare_variant_price + engraving_compare_price), currencyFormat))
      if($.trim($('#engraving_text-input').val()).length > 0){
        $(this).closest('.product-single__meta').find('[data-add-to-cart]').show();
        $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').hide();
      }else{
        $(this).closest('.product-single__meta').find('[data-add-to-cart]').hide();
        $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').show();
      }
    } else {
      $(this).closest('.product-single__meta').find('[data-product-price]').html(formatMoney(current_variant_price, currencyFormat))
      $(this).closest('.product-single__meta').find('[data-compare-price]').html(formatMoney(current_compare_variant_price, currencyFormat))
      $(this).closest('.product-single__meta').find('[data-add-to-cart]').show();
      $(this).closest('.product-single__meta').find('.blank-engraving-field-shadow-btn').hide();
    }  
  });

  $('.gifting-form-thank-you_button').click(function(e){
    e.preventDefault();
   // Trigger PDF download
    fetch('https://cdn.shopify.com/s/files/1/0503/5442/1920/files/gifting-catalogue.pdf?v=1759235015')
    .then(resp => resp.blob())
    .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'gifting-catalogue.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    })
    .catch(() => alert('Failed to download file')); 
  });
});


function isPartiallyInView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if any part of the element is visible
  return elementBottom > viewportTop && elementTop < viewportBottom;
}

function isFullyOutOfView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if element is entirely above or below the viewport
  return elementBottom <= viewportTop || elementTop >= viewportBottom;
}

function counterFun() {
  var $counter = $('.counter');
  if (!$counter.length) return;

  if (isPartiallyInView($counter)) {
    $('.count').each(function () {
      var $this = $(this);
      var countTo = parseInt($this.attr('data-count'), 10);

      if (!$this.hasClass('counted')) {
        $this.addClass('counted');
        $({ countNum: 0 }).animate(
          { countNum: countTo },
          {
            duration: 2000,
            easing: 'swing',
            step: function () {
              // Add commas while animating
              $this.text(Math.floor(this.countNum).toLocaleString());
            },
            complete: function () {
              // Final value with commas
              $this.text(countTo.toLocaleString());
            }
          }
        );
      }
    });
  } else if (isFullyOutOfView($counter)) {
    // Reset only when fully out of view
    $('.count').each(function () {
      $(this).removeClass('counted').text('0');
    });
  }
}


$(window).on('scroll resize', counterFun);
$(document).ready(counterFun);

$(document).ready(function () {
  $('.process-videos_item-play-btn').on('click', function () {
    var $btn = $(this);
    var $video = $btn.siblings('video')[0];

    // If same video is playing → pause it
    if (!$video.paused && !$video.ended) {
      $video.pause();
      return;
    }

    // Pause all other videos and remove their .active
    $('video').each(function () {
      if (this !== $video) {
        this.pause();
        this.currentTime = 0;
        $(this).siblings('.process-videos_item-play-btn').removeClass('active');
      }
    });

    // Play the clicked video
    $video.play();
  });

  // ✅ Add .active when video starts playing
  $('video').on('play', function () {
    $(this).siblings('.process-videos_item-play-btn').addClass('active');
  });

  // ❌ Remove .active when video pauses or ends
  $('video').on('pause ended', function () {
    $(this).siblings('.process-videos_item-play-btn').removeClass('active');
  });

  $('a[href^="#"]').on('click', function(e) {
    e.preventDefault();
  
    var targetId = $(this).attr('href');
    var targetElement = $(targetId);
  
    if (targetElement.length) {
      var offsetTop = targetElement.offset().top - 120;
  
      $('html, body').animate({
        scrollTop: offsetTop
      }, 600); // 600ms animation duration
    }
  });

  
  $('.offer-convenience-media_items-list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.offer-convenience-content_col-blocks-list',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
          }
        }
      ]
  });
  $('.offer-convenience-content_col-blocks-list').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      vertical:true,
      asNavFor: '.offer-convenience-media_items-list',
      dots: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: false,
            vertical: false,
          }
        }
      ]
  });

  // $('.favorite-character_items-list').slick({
  //       slidesToShow: 8,
  //       slidesToScroll: 1,
  //       autoplay: true,
  //       autoplaySpeed: 1,
  //       speed: 6000,
  //       dots: false,
  //       arrows: false,
  //       cssEase: 'linear',
  //       waitForAnimate: false,
  //       pauseOnFocus: true, 
  //       pauseOnHover: true,
  //       responsive: [
  //           {
  //               breakpoint: 740,
  //               settings: {
  //                   slidesToShow: 3,
  //                   slidesToScroll: 1,
  //               }
  //           }
  //       ]
  //   });

    $('.featured-coll-sli-list').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 3,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            arrows: false,
            dots: true
          }
        }
      ]
  });

  $('.core-principles_list-item').click(function(){
    $('.core-principles_list-item').removeClass('active');
    $(this).addClass('active');
    $('.core-principles_description').hide();
    
    var activeTab = $(this).attr('data-id');
    $(activeTab).fadeIn();
    return false;
  });

  $('body').on('click', '.product-grid-item-atc', function (e) {
    e.preventDefault();
    this.setAttribute('disabled', 'disabled');
    $(this).addClass('btn--loading');

    var variant_id = parseInt($(this).attr('variant_id'));
    var _this = this;
    console.log('variant_id', variant_id);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      // async: false,
      data: { 
        quantity: 1, 
        id: variant_id
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        
        $(_this).removeAttr('disabled');
        $(_this).removeAttr('aria-busy');
        $(_this).removeClass('loading');
      },
      success: function() {
        $(_this).removeAttr('disabled');
        $(_this).removeClass('btn--loading');
        console.log('success');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }
    });
  });

  $('body').on('click', '.addon-product-atc', function (e) {
    e.preventDefault();
    this.setAttribute('disabled', 'disabled');
    $(this).addClass('btn--loading');

    var variant_id = parseInt($(this).attr('variant_id'));
    var _this = this;
    console.log('variant_id', variant_id);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      // async: false,
      data: { 
        quantity: 1, 
        id: variant_id
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        
        $(_this).removeAttr('disabled');
        $(_this).removeAttr('aria-busy');
        $(_this).removeClass('loading');
      },
      success: function() {
        $(_this).removeAttr('disabled');
        $(_this).removeClass('btn--loading');
        console.log('success');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }
    });
  });

  // if (window.innerWidth < 768) { // mobile breakpoint
  //   $('.ideal-size_content-title').click(function () {
  //     $(this).toggleClass('active');
  //     $(this).next('.ideal-size_content-box').slideToggle();
  //   });
  // }

  $('.logo-with-content_items-content_list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.logo-with-content_items-media_list'
  });
  $('.logo-with-content_items-media_list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay:true,
      infinite: true,
      asNavFor: '.logo-with-content_items-content_list',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
          }
        }
      ]
  });

  // document.querySelectorAll('.download-link').forEach(el => {
  //   el.addEventListener('click', function(e) {
  //       e.preventDefault(); 
  //       const fileUrl = this.getAttribute('href');
  //       const fileName = this.getAttribute('download') || 'Catalogue.pdf';

  //       fetch(fileUrl)
  //       .then(resp => resp.blob())
  //       .then(blob => {
  //           const url = window.URL.createObjectURL(blob);
  //           const a = document.createElement('a');
  //           a.href = url;
  //           a.download = fileName;
  //           document.body.appendChild(a);
  //           a.click();
  //           a.remove();
  //           window.URL.revokeObjectURL(url);
  //       })
  //       .catch(() => alert('Failed to download file'));
  //   });
  // });

  $('.videos-with-side-video_poster').on('click', function() {
    var $parent = $(this).closest('.videos-with-side-video');
    var $video = $parent.find('video').get(0); // get raw DOM element

    // Play video
    if ($video.paused) {
      $video.play();
      $parent.addClass('play');
    } else {
      $video.pause();
      $parent.removeClass('play');
    }
  });

  $('body').on('click', '.we-got-featured-logo-block', function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    const tabBtn = $(this).attr('data-logo');    
    $('.we-got-featured-text-block').each(function (){
      const tabContent = $(this).attr('data-text');
      console.log('tabBtn',tabBtn);
      console.log('tabContent',tabContent);
      if (tabBtn === tabContent) {
        $(this).siblings().removeClass('active');
        $(this).addClass('active');        
      }
    })
    
  })

  $('body').on('click','.video-sec-btn', function(){    
    const video = $(this).closest('.video-secondary-video').find('video')[0];
      video.play();
      video.controls = true;
      $(this).remove();
  });

  // function freeitemscheck(cart){
  //   $('.cart__checkout-wrapper').hide();
  //   $('.btn.cart__checkout').removeAttr('name');

  //   if(theme.settings.receipt_item_enable){

  //     // ✅ ADD THIS GUARD — if receipt item isn't configured, bail out safely
  //     if(!theme.settings.receipt_item || !theme.settings.receipt_item.variants){
  //       console.warn('receipt_item not configured in theme settings');
  //       $('.cart__checkout-wrapper').show();
  //       $('.btn.cart__checkout').attr('name', 'checkout');
  //       // still apply the total_price check below
  //     } else {

  //       var cartotal = 0;
  //       var threshold = parseFloat(theme.settings.receipt_item_threshold);
  //       var receiptitem = theme.settings.receipt_item;
  //       var receiptitemexist = cart.items.find(i => i.product_id == receiptitem.id);

  //       cart.items.forEach(function(item) {
  //         if (item.product_id != receiptitem.id) {
  //           cartotal += item.final_line_price;
  //         }
  //       });

  //       var updateData = {};
  //       var items = [];
  //       cartotal = cartotal / 100;

  //       var rate = window.Shopify.currency.rate || 1;
  //       var receiptvaluethresh = threshold * rate;

  //       if(cartotal > receiptvaluethresh && !receiptitemexist){    
  //         items.push({
  //           quantity: 1,
  //           id: receiptitem.variants[0].id,  // ✅ safe now
  //           properties: { '_freereceiptitem': true }
  //         }); 
  //       } else if(cartotal < receiptvaluethresh && receiptitemexist){
  //         updateData[receiptitemexist.key] = 0;             
  //       }

  //       if(Object.keys(updateData).length != 0){
  //         $.ajax({
  //           type: 'POST',
  //           url: '/cart/update.js',
  //           data: { updates: updateData },
  //           dataType: 'json',
  //           async: false,
  //           success: function(data) {   
  //             if(items.length == 0){
  //               document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  //             }
  //             $('.cart__checkout-wrapper').show();
  //             $('.btn.cart__checkout').attr('name', 'checkout');
  //           },
  //           error: function(jqXHR) { console.log(jqXHR); }
  //         });
  //       } else {
  //         $('.cart__checkout-wrapper').show();
  //         $('.btn.cart__checkout').attr('name', 'checkout');
  //       }

  //       if(items.length > 0){
  //         fetch(theme.routes.cartAdd, {
  //           method: 'POST',
  //           body: JSON.stringify({items}),
  //           credentials: 'same-origin',
  //           headers: {
  //             'Content-Type': 'application/json; charset=UTF-8',
  //             'X-Requested-With': 'XMLHttpRequest'
  //           }
  //         })
  //         .then(response => response.json())
  //         .then(function(data) {
  //           console.log(data);
  //           document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  //           $('.cart__checkout-wrapper').show();
  //         }.bind(this));  
  //       } else {
  //         $('.cart__checkout-wrapper').show();
  //         $('.btn.cart__checkout').attr('name', 'checkout');
  //       }

  //     } // ← end of receipt_item guard else block

  //   } else {
  //     $('.cart__checkout-wrapper').show();
  //     $('.btn.cart__checkout').attr('name', 'checkout');
  //   }

  //   // ✅ Also fix: divide by 100 to compare actual price, not cents
  //   if((cart.total_price / 100) < 10){
  //     $('.cart__checkout-wrapper').hide();
  //     $('.btn.cart__checkout').removeAttr('name');
  //   }
  // }

  var freeItemBusy = false;

  function freeItemsCheck() {
    var cfg = (window.theme && theme.settings && theme.settings.freeItem) || {};

    if (!cfg.enable || !cfg.variantId) return;
    if (freeItemBusy) return;
    freeItemBusy = true;

    $.getJSON('/cart.js', function (cart) {
      var excludeIds = cfg.excludeIds || [];
      var giftLine = null;
      var eligibleUnits = 0;
      var hasExcluded = false;

      $.each(cart.items, function (i, item) {
        var isGift = item.product_id === cfg.productId ||
          (item.properties && (item.properties._free_gift === 'true' || item.properties._free_gift === true));

        if (isGift) {
          giftLine = item;
        } else {
          eligibleUnits += item.quantity;
        }

        if ($.inArray(item.product_id, excludeIds) !== -1) {
          hasExcluded = true;
        }
      });

      // One eligible (non-gift) item is enough; excluded products block the gift.
      var shouldHaveGift = eligibleUnits > 0 && !hasExcluded;

      function finish() {
        freeItemBusy = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
      }

      if (shouldHaveGift && !giftLine) {
        // Add the free item
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: cfg.variantId,
            quantity: 1,
            properties: { _free_gift: 'true' }
          },
          dataType: 'json',
          success: finish,
          error: function () { freeItemBusy = false; }
        });
      } else if (!shouldHaveGift && giftLine) {
        // Remove the free item
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: { id: giftLine.key, quantity: 0 },
          dataType: 'json',
          success: finish,
          error: function () { freeItemBusy = false; }
        });
      } else if (giftLine && giftLine.quantity !== 1) {
        // Safety: keep the free item pinned to a single unit
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: { id: giftLine.key, quantity: 1 },
          dataType: 'json',
          success: finish,
          error: function () { freeItemBusy = false; }
        });
      } else {
        // Nothing to do
        freeItemBusy = false;
      }
    }).fail(function () {
      freeItemBusy = false;
    });
  }

  

  /*============================================================================
    Cart drawer related items
    - Fetches recommendations for the FIRST (non free-gift) item in the cart
      via Shopify's Product Recommendations API (Search & Discovery).
    - Re-renders whenever the first item changes (e.g. first item removed).
    - Each card has a variant <select> + ATC (ATC reuses .product-grid-item-atc).
    - Config from theme.settings.cartRelated (see layout/theme.liquid).
  ==============================================================================*/
  var cartRelatedLastId = null;

  function cartRelatedItemsCheck() {
    var cfg = (window.theme && theme.settings && theme.settings.cartRelated) || {};
    var $container = $('[data-cart-related-products]');

    if (!cfg.enable || !$container.length) return;

    $.getJSON('/cart.js', function (cart) {
      // First item that is not the auto free gift.
      var first = null;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var isGift = item.properties && (item.properties._free_gift === 'true' || item.properties._free_gift === true);
        if (!isGift) { first = item; break; }
      }

      if (!first) {
        $container.hide().empty();
        cartRelatedLastId = null;
        return;
      }

      // Skip refetch if the first product hasn't changed.
      if (first.product_id === cartRelatedLastId && $container.children().length) return;
      cartRelatedLastId = first.product_id;

      console.log(first)
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root + 'recommendations/products'
        + '?section_id=cart-recommendations'
        + '&product_id=' + first.product_id
        + '&intent=' + (cfg.intent || 'related')
        + '&limit=' + (cfg.limit || 4);

      $.get(url, function (html) {
        var $html = $('<div>').html(html);
        if ($html.find('.related-item').length === 0) {
          $container.hide().empty();
          return;
        }
        $container.html(html).show();
      }).fail(function () {
        $container.hide().empty();
      });
    });
  }

  // Update the ATC button's variant + displayed price when a variant is picked.
  $(document).on('change', '.related-variant-select', function () {
    var $select = $(this);
    var $card = $select.closest('.related-item');
    var $option = $select.find('option:selected');
    var $btn = $card.find('.related-atc');

    $btn.attr('variant_id', $select.val());

    if ($option.is(':disabled')) {
      $btn.attr('disabled', 'disabled');
    } else {
      $btn.removeAttr('disabled');
    }

    var price = $option.attr('data-price');
    if (price !== undefined && price !== '') {
      $card.find('.product-price').html(formatMoney(price, currencyFormat));
    }
  });

  // Re-check after any cart change handled by the theme, and on initial load.
  $(document).on('ajaxProduct:added', function () { 
      freeItemsCheck()
      cartRelatedItemsCheck();
  });
  $(document).on('cart:updated', function () { 
      freeItemsCheck()
      cartRelatedItemsCheck();
  });
  freeItemsCheck();
  cartRelatedItemsCheck();

  var $video = $('#custom-video');
  var $button = $('#custom-play-btn');
  var videoEl = $video.get(0);

  $button.on('click', function () {
    if (videoEl.paused) {
      videoEl.play();
      $button.addClass('active'); // Change button text to "Pause"
    } else {
      videoEl.pause();
      $button.removeClass('active'); // Change back to "Play"
    }
  });

  $('.gv-cta-btn').on('click', function(e) {
    e.preventDefault();

    var target = $($(this).attr('href')); // resolves to #giveaway-rules

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 110
      }, 600);
    }
  });

  $('.form_bottom_text a').on('click', function(e) {
    e.preventDefault();

    var target = $($(this).attr('href')); // resolves to #giveaway-rules

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 110
      }, 600);
    }
  });
});


$(document).on('click', '[data-copy-code]', function () {
  const $button = $(this);
  const code = $button.attr('data-code');

  if (!code || !navigator.clipboard) return;

  navigator.clipboard.writeText(code).then(function () {
    $button.addClass('is-copied');

    setTimeout(function () {
      $button.removeClass('is-copied');
    }, 2000);
  });
});